import React from 'react'
import PropTypes from 'prop-types'
import styles from './YourGoals.module.scss'

const YourGoals = (props) => {
  const {
    goalsList,
  } = props

  return (
    <div className={styles.container}>
      <label>
           your goals
      </label>
      <ul className={styles.listContainer} data-test-id="yourGoals">
        {goalsList &&  goalsList.length > 0 &&
            goalsList.map(item => <li key={item} className={styles.listItem}>{item}</li>)
        }
      </ul>
    </div>
  )
}

YourGoals.defaultProps = {
  goalsList: [],
}

YourGoals.propTypes = {
  goalsList: PropTypes.array,
}

export default YourGoals



// WEBPACK FOOTER //
// ./src/components/Client/GoalsAndInvestmentStrategy/YourGoals/YourGoals.jsx